import React from 'react';

function EPComments() {
  return (
    <div>EPComments</div>
  );
}

export default EPComments;
